var _defs, _g, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInviteSent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .invite-sent-class-a {\n        fill: white;\n      }\n      .invite-sent-class-b {\n        fill: none !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_531_6130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.429 4H4.714C4.25982 4.00132 3.82463 4.18232 3.50348 4.50348C3.18232 4.82463 3.00132 5.25982 3 5.714V16C3.00132 16.4542 3.18232 16.8894 3.50348 17.2105C3.82463 17.5317 4.25982 17.7127 4.714 17.714H12.428V16H4.714V7.429L11.571 11.715L18.428 7.429V11.715H20.142V5.715C20.1409 5.26082 19.9602 4.82552 19.6392 4.50418C19.3183 4.18284 18.8832 4.00158 18.429 4ZM11.572 10L4.714 5.714H18.429L11.572 10ZM17.572 13.429L21 16.857L17.571 20.286V17.714H14.143V16H17.572V13.429Z",
    className: "invite-sent-class-a"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_6130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    className: "invite-sent-class-b"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInviteSent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/invite_sent.bddc957e9db6a91063810d7be996d424.svg";